import styled, { css } from 'styled-components';

export const LBContainer = styled.div.attrs(props => ({
    "max-height":props["max-height"] || '160px',
    "min-height":props["min-height"] || '64px',
    "max-width":props["max-width"] || '100%',
}))`
    border: 1px solid lightgray;
    border-radius: 3px;
    background-color: white;
    max-height: ${props => props["max-height"]};
    min-height: ${props => props["min-height"]};
    max-width: ${props => props["max-width"]};
    overflow-x: hidden;
    overflow-y: auto;
    cursor: pointer;
    padding: 4px;
    user-select: none;
`;
export const LBItem = styled.div.attrs(props => ({
    "max-height":props["max-height"] || '160px',
    "max-width":props["max-width"] || '100%',
    selected:!!props.selected || false,
}))`
    padding: 4px;

    ${props => props.selected && css`
        color: rgba(255, 255, 255, 1);
        background-color: #137cbd;
        & :hover {
            background-color: rgba(19, 124, 189, 0.85);
        }
    `}
    ${props => !props.selected && css`
        & :hover {
            background-color: rgba(19, 124, 189, 0.2);
        }
    `}

`;